export const CREDIT_MIN_VALUE = 0
export const POINT_MIN_VALUE = 0
export const POINT_MAX_VALUE = 99
export const EMPTY_COVER = "/images/empty-cover.png"
export const DEFAULT_USER_COVER = "/images/user-icon.jpg"
export const PHONE_TIMEOUT = 60
export const MAX_FILE_SIZE_MB = 10
export const MAX_COMPRESSED_FILE_SIZE_KB = 250
export const PER_PAGE = 48

export const SWAPPER_PER_PAGE = 30
export const SWAPPER_PAGES = 3

export const LANGUAGE_COOKIE_NAME = "language"
export const REFERRAL_CODE_COOKIE_NAME = "referralCode"
export const ORIGINAL_ROUTE_COOKIE_NAME = "originalRoute"
export const MOBILE_BANNER_COOKIE_NAME = "mobileAppBanner"

export const BOOK_CONDITIONS = [
  "new",
  "excellent",
  "good",
  "satisfactory",
] as const

export const SYMBOL_MAP = {
  find: "äąåàâáąāõøôœóōéèêëęėēîïįīûųūčćģķļłņńšśźżž",
  replace: "aaaaaaaaooooooeeeeeeeiiiiuuuccgkllnnsszzz",
} as const

export const BOOK_FORMATS = {
  HARDBACK: "Hardback",
  PAPERBACK_SOFTBACK: "Paperback / softback",
  SEMI_HARD: "Semi-Hard",
  POCKET: "Pocket",
} as const

export const COUNTRY_BOOK_FORMATS = {
  lt: [
    BOOK_FORMATS.HARDBACK,
    BOOK_FORMATS.SEMI_HARD,
    BOOK_FORMATS.PAPERBACK_SOFTBACK,
  ],
  ee: [BOOK_FORMATS.HARDBACK, BOOK_FORMATS.PAPERBACK_SOFTBACK],
  fr: [
    BOOK_FORMATS.HARDBACK,
    BOOK_FORMATS.PAPERBACK_SOFTBACK,
    BOOK_FORMATS.POCKET,
  ],
} as const
